import React, { useEffect, useState } from "react";

import {
    Navbar,
    MobileNav,
    Typography,
    Button,
    IconButton,
    Card,
    Input
} from "@material-tailwind/react";
import logo from "../../assets/logo_only.png"

import { slide as Menu } from 'react-burger-menu'
import { FaCalculator, FaFacebook, FaHouse, FaHouseChimneyWindow, FaInstagram, FaSistrix, FaTiktok, FaUsers, FaUsersRays, FaYoutube } from "react-icons/fa6";
import { setSearchObj } from "../../helper/localStorage";
import { toast } from "react-toastify";
import { WBLabel } from "./WBLabel";
import LogoName from "./LogoName";

export default function NavigationBar ({
    fixed
}) {

    const [openNav, setOpenNav] = useState(false);
    const [queryName, setQueryName] = useState('')
 
    useEffect(() => {
        window.addEventListener("resize", () => window.innerWidth >= 960 && setOpenNav(false) );
    }, []);
 
    const navList = (
        <ul className="mt-2 mb-4 flex flex-col gap-2 md:mb-0 md:mt-0 md:flex-row md:items-center md:gap-6">
        <Typography
            as="li"
            variant="medium"
            color="blue-gray"
            className="p-0 font-bold"
        >
            <a href="/" className="flex items-center">
            Beranda
            </a>
        </Typography>
        <Typography
            as="li"
            variant="medium"
            color="blue-gray"
            className="p-0 font-bold"
        >
            <a href="/listing" className="flex items-center">
            Rumah Dijual
            </a>
        </Typography>
        {/* <Typography
            as="li"
            variant="medium"
            color="blue-gray"
            className="p-0 font-bold"
        >
            <a href="/proyek" className="flex items-center cursor-pointer">
            Rumah Baru
            </a>
        </Typography> */}
        <Typography
            as="li"
            variant="medium"
            color="blue-gray"
            className="p-0 font-bold"
        >
            <a href="/agents" className="flex items-center">
            Agent Maxx Property
            </a>
        </Typography>
        <Typography
            as="li"
            variant="medium"
            color="blue-gray"
            className="p-0 font-bold"
        >
            <a href="/about-us" className="flex items-center">
            Tentang Kami
            </a>
        </Typography>
        <Typography
            as="li"
            variant="medium"
            color="blue-gray"
            className="p-0 font-bold"
        >
            <a href="/kalkulator-kpr" className="flex items-center">
            Kalkulator KPR
            </a>
        </Typography>
        </ul>
    );

    return (
        <>
            <Navbar className="sticky backdrop-blur-sm backdrop-filter top-0 z-10 h-max max-w-full rounded-none px-4 py-4 hidden md:block md:px-12 lg:py-2">
                <div className="flex items-center justify-between text-blue-gray-900">
                    <div className="flex items-center">
                        <Typography
                            as="a"
                            href="/"
                            className="mr-4 cursor-pointer font-medium"
                        >
                            <div className="flex items-center">
                                <img src={logo} width={64} height={64}/>
                                <WBLabel className={"text-blue-maxx font-arial mt-1"} size={20} bold text={""}/>
                                <LogoName />
                            </div>
                        </Typography>
                        <div className="flex items-center gap-4">
                            <div className="ml-4 hidden md:block">{navList}</div>
                        </div>
                    </div>
                    <div className="justify-end">
                        <Input 
                            placeholder="Search"
                            className="!border !border-gray-300 bg-white text-gray-900 shadow-lg shadow-gray-900/5 ring-4 ring-transparent placeholder:text-gray-500 placeholder:opacity-100 focus:!border-gray-900 focus:!border-t-gray-900"
                            labelProps={{className: "hidden"}}
                            containerProps={{className: "min-w-0"}}
                            onChange={(e) => { setQueryName(e.currentTarget.value) }}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter') { 
                                    setSearchObj({queryName})
                                    window.location.href = "/listing"
                                }
                            }}
                            icon={<FaSistrix/>}
                        />
                    </div>
                </div>
            </Navbar>
            <div className={`${fixed ? 'sticky top-0 bg-white' : 'relative'} z-10 h-max max-w-full md:hidden`}>
                <div className="flex align-center justify-between items-center px-4 py-4">
                    <div className="flex items-center" onClick={() => { window.location.href = '/'}}>
                        <img src={logo} width={48} height={48}/>
                        <LogoName fontSize={14} />
                    </div>
                    <div>
                        <Menu right>
                            <div>
                                <div className="flex items-center">
                                    <img onClick={() => { window.location.href = '/'}} src={logo} width={48} height={48}/>
                                    <WBLabel size={18} bold text={"Maxx Property"}/>
                                </div>
                                {/* <div className="flex mt-6 menu-item text-right justify-between items-center">
                                    <img onClick={() => { window.location.href = '/'}} src={logo} width={48} height={48}/>
                                </div> */}
                                <div className="flex mt-4 menu-item text-[16px]">Cari rumah mudah dan lengkap di Maxx Property</div>
                                <div className="flex mt-4 menu-item gap-x-1">
                                    <div className="rounded-full p-1.5 w-30 h-30 bg-[#616161]"><FaInstagram onClick={() => { toast('instagram') }} className="text-[white] text-[18px]"/></div>
                                    <div className="rounded-full p-1.5 w-30 h-30 bg-[#616161]"><FaYoutube onClick={() => { toast('youtube') }} className="text-[white] text-[18px]"/></div>
                                    <div className="rounded-full p-1.5 w-30 h-30 bg-[#616161]"><FaFacebook onClick={() => { toast('facebook') }} className="text-[white] text-[18px]"/></div>
                                    <div className="rounded-full p-1.5 w-30 h-30 bg-[#616161]"><FaTiktok onClick={() => { toast('tiktok') }} className="text-[white] text-[18px]"/></div>
                                </div>
                            </div>
                            <div className="h-[0.5px] bg-[#80808080] mt-8 mb-8"/>
                            <a id="home" className="menu-item mt-8 mb-8" href="/"><div className="flex items-center"><FaHouse className="mr-2"/><span className="text-[18px]">Beranda</span></div></a>
                            <a id="listing" className="menu-item mt-8 mb-8" href="/listing"><div className="flex items-center"><FaHouseChimneyWindow className="mr-2"/><span className="text-[18px]">Rumah Dijual</span></div></a>
                            {/* <a id="proyek" className="menu-item mt-8 mb-8" href="/proyek"><div className="flex items-center"><FaHouseChimneyWindow className="mr-2"/><span className="text-[18px]">Rumah Baru</span></div></a> */}
                            <a id="agents" className="menu-item mt-8 mb-8" href="/agents"><div className="flex items-center"><FaUsers className="mr-2"/><span className="text-[18px]">Agent Maxx Property</span></div></a>
                            <a id="about-us" className="menu-item mt-8 mb-8" href="/about-us"><div className="flex items-center"><FaUsersRays className="mr-2"/><span className="text-[18px]">Tentang Kami</span></div></a>
                            <a id="kalkulator-kpr" className="menu-item mt-8 mb-8" href="/kalkulator-kpr"><div className="flex items-center"><FaCalculator className="mr-2"/><span className="text-[18px]">Kalkulator KPR</span></div></a>
                        </Menu>
                    </div>
                </div>
                {/* <div className="h-[0.5px] bg-[#80808080]"/> */}
            </div>
        </>
    )
}